import { useSelector } from "react-redux";
import { ExclamationTriangleIcon } from "@heroicons/react/20/solid";
import { useEffect, useState } from "react";

const AppLicenseInfo = () => {
  const tenantInfo = useSelector((state: any) => state.tenant.get("tenantInfo"));
  const activeLicense = tenantInfo.getIn(["license", "active"]);
  const [close, setClose] = useState(true);
  useEffect(() => {
    setClose(activeLicense);
  }, [activeLicense]);

  if (close == false) {
    window.needCheckSaleCRMLicense = true;
    return (
      <div className="rounded-md bg-yellow-50 p-4">
        <div className="flex">
          <div className="shrink-0">
            <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" aria-hidden="true" />
          </div>
          <div className="ml-3">
            <h3 className="text-sm font-medium text-yellow-800">Attention needed</h3>
            <div className="mt-2 text-sm text-yellow-700 space-x-1.5 flex">
              <p>Your CRM License is expired and invalid.</p>
              <span className={"text-blue-600"}>
                <a
                  href={
                    "https://jsoftconnector.atlassian.net/servicedesk/customer/portal/1/group/1/create/59"
                  }
                >
                  Raise a support
                </a>
              </span>
            </div>
          </div>
          <div
            className={"text-blue-500 absolute right-4 cursor-pointer"}
            onClick={() => {
              setClose(true);
            }}
          >
            close
          </div>
        </div>
      </div>
    );
  }
  return null;
};

export default AppLicenseInfo;
